import React from 'react';
import { GRID } from '@/utils/constants';
import { Clip } from './Clip';

export const TrackGrid = ({
  track,
  totalBars,
  playheadBar = 0,
  activeTool,
  selectedClipIds,
  onSelectClip,
  onMoveClip,
  onSliceClip,
  onDuplicateClip,
  onDeleteClip,
  onTrimClipEdge,
  onResetClip, onLoopClip,
  onEditPattern, onMakeUnique, onClipSound,
  kiosk,
  sessionBpm,
  pxPerBar = GRID.PX_PER_BAR,
  rowHeight = GRID.TRACK_HEIGHT,
  allowClipSound = true,
  highlightClip = null,
  highlightBar = null,
}) => {
  const totalWidth = totalBars * pxPerBar;

  // Deselect when clicking empty grid area
  const handleGridClick = (e) => {
    if (e.target === e.currentTarget) {
      onSelectClip?.(null);
    }
  };

  return (
    <div
      data-testid={`track-grid-${track.id}`}
      className="relative flex-1"
      onClick={handleGridClick}
      style={{
        height: rowHeight,
        width: totalWidth,
        minWidth: totalWidth,
      }}
    >
      {/* Grid lines */}
      {Array.from({ length: totalBars }, (_, i) => (
        <div
          key={i}
          className="absolute top-0 h-full pointer-events-none"
          style={{
            left: i * pxPerBar,
            width: 1,
            background: i % 4 === 0 ? 'rgba(255,255,255,0.06)' : 'rgba(255,255,255,0.025)',
          }}
        />
      ))}

      {/* Quarter-note subdivisions */}
      {Array.from({ length: totalBars * 4 }, (_, i) => {
        if (i % 4 === 0) return null;
        return (
          <div
            key={`q${i}`}
            className="absolute top-0 h-full pointer-events-none"
            style={{
              left: i * (pxPerBar / 4),
              width: 1,
              background: 'rgba(255,255,255,0.012)',
            }}
          />
        );
      })}

      {/* Clips with full interaction props */}
      {track.clips.map((clip) => (
        <Clip
          key={clip.id}
          clip={clip}
          maxEndBar={totalBars}
          trackId={track.id}
          activeTool={activeTool}
          isSelected={selectedClipIds?.has(clip.id)}
          onSelect={onSelectClip}
          onMove={onMoveClip}
          onSlice={onSliceClip}
          onDuplicate={onDuplicateClip}
          onDelete={onDeleteClip}
          onTrim={onTrimClipEdge}
          onReset={onResetClip}
          onLoop={onLoopClip}
          onEditPattern={onEditPattern}
          onMakeUnique={onMakeUnique} onClipSound={onClipSound}
          kiosk={kiosk}
          sessionBpm={sessionBpm}
          pxPerBar={pxPerBar}
          audioEligible={!(track.classSlot && track.muted)}
          classMuted={Boolean(track.classSlot && track.muted)}
          allowClipSound={allowClipSound}
          highlighted={highlightClip === true || highlightClip === clip.id}
        />
      ))}

      {Number.isFinite(highlightBar) && <div data-testid={`class-highlight-track-${track.id}`} className="class-highlight-track class-highlight" style={{ left: highlightBar * pxPerBar }} />}

      {/* Playhead — NO CSS transition, driven directly by RAF */}
      <div
        data-testid="playhead-lane"
        className="absolute top-0 pointer-events-none"
        style={{
          left: playheadBar * pxPerBar,
          width: 2,
          height: '100%',
          background: 'var(--green)',
          zIndex: 5,
        }}
      />
    </div>
  );
};

export default TrackGrid;
